import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, AlertTriangle, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function BillingBanner() {
  const [status, setStatus] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    api.get("/me/company")
      .then(({ data }) => {
        // Locations linked to a corporate are covered by the corporate's bill — hide per-location banner.
        if (data?.corporate_id) setHidden(true);
      })
      .catch(() => {});
    api.get("/billing/status")
      .then(({ data }) => setStatus(data))
      .catch(() => {});
  }, []);

  if (hidden) return null;
  if (!status) return null;
  if (status.status === "active" && status.days_left > 7) return null; // healthy → no banner

  if (status.status === "expired") {
    return (
      <div className="bg-destructive text-white px-5 py-2.5 flex items-center justify-between gap-3" data-testid="billing-banner-expired">
        <div className="flex items-center gap-2 text-sm">
          <AlertTriangle className="h-4 w-4" />
          <span><span className="font-semibold">Subscription expired.</span> Your team cannot sign in and your console is limited to Billing until you renew.</span>
        </div>
        <Link to="/admin/billing" className="text-sm font-semibold underline inline-flex items-center gap-1" data-testid="billing-banner-cta">
          Renew now <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
    );
  }

  if (status.status === "trial") {
    return (
      <div className="bg-amber-50 border-b border-amber-200 text-amber-900 px-5 py-2.5 flex items-center justify-between gap-3" data-testid="billing-banner-trial">
        <div className="flex items-center gap-2 text-sm">
          <Sparkles className="h-4 w-4" />
          <span>
            <span className="font-semibold">{status.days_left}</span> day{status.days_left === 1 ? "" : "s"} left in your free trial · ${status.monthly_price_usd}/mo to keep going.
          </span>
        </div>
        <Link to="/admin/billing" className="text-sm font-semibold text-amber-900 hover:underline inline-flex items-center gap-1" data-testid="billing-banner-cta">
          Upgrade <ArrowRight className="h-3 w-3" />
        </Link>
      </div>
    );
  }

  // active but close to renewal
  return (
    <div className="bg-slate-100 border-b border-slate-200 text-slate-700 px-5 py-2.5 flex items-center justify-between gap-3" data-testid="billing-banner-renewal">
      <div className="text-sm">
        Subscription renews in <span className="font-semibold">{status.days_left}</span> day{status.days_left === 1 ? "" : "s"}.
      </div>
      <Link to="/admin/billing" className="text-sm font-medium text-primary hover:underline" data-testid="billing-banner-cta">
        Manage billing →
      </Link>
    </div>
  );
}
